module.exports = __webpack_public_path__ + "img/bruce-brenneise-promo-final.6b0bc833.jpg";